/* eslint-disable no-unneeded-ternary */
import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'

import { getMatchPlayers } from '@shared/libs/match-detail'
import { DownArrow } from '@shared/components/ctIcons'
import SpiderBatterData from '../spiderData'
import ScoreTimeLine from '../timeLine'
import ScorePlayerDetail from '../scorePlayerDetail'
import MyImage from '@shared/components/myImage'
import { useLazyQuery } from '@apollo/client'
import { GET_BATSMAN_STATS_SCORECARD } from '@graphql/match/match.query'
import { getImgURL } from '@shared-submodule/utils'
import playerPlaceholder from '@assets/images/placeholder/Placeholder_Player.svg'
import Commentary from '../commentary'
import dynamic from 'next/dynamic'
import { Nav } from 'react-bootstrap'
import navStyles from '@shared/components/commonNav/style.module.scss'
import BowlerOvers from '../bowlerOvers'
const NoData = dynamic(() => import('@shared/components/noData'), { ssr: false })

const BatterDataRow = ({ batter, table, capwk, matchDetail, currentTeam }) => {
  const [downDown, setDropdown] = useState(false)
  const [battingState, setBattingState] = useState('Batting')
  const [activeTab, setActiveTab] = useState('all')
  const allPlayers = getMatchPlayers()
  const player = allPlayers[batter?.iBatterId] || batter?.oBatter
  const playerSlug = player?.oSeo?.sSlug
  const isCaptain = batter?.oBatter?.isCaptain ? '( c )' : ''
  const isWk = batter?.oBatter?.isWk ? '(wk)' : ''
  const isCandW = batter?.oBatter?.isCaptain && batter?.oBatter?.isWk ? '(c & wk)' : ''

  const [getPlayerStats, { data: playerStats, loading }] = useLazyQuery(GET_BATSMAN_STATS_SCORECARD)

  function handleDropdown() {
    setDropdown(prev => !prev)
    getPlayerStats({
      variables: {
        input: {
          iMatchId: matchDetail?._id,
          iPlayerId: batter?.iBatterId
        }
      }
    })
  }

  function handleBattingState(type) {
    setBattingState(type)
  }

  const aStats = playerStats?.getPlayerMatchStats?.oPlayerMatchStats?.aStats || []
  const currentStats = aStats?.find(stat => stat?.nInningNumber === currentTeam)

  const paceStats = currentStats?.oBatStats?.aRunsByBowlerType?.find(item => item?.sType === 'PACE') || {}
  const spinStats = currentStats?.oBatStats?.aRunsByBowlerType?.find(item => item?.sType === 'SPIN') || {}

  const partnerships = currentStats?.oBatStats?.oBattingMetrics?.aPartnerships || []
  const p2pData = currentStats?.oBatStats?.oBattingMetrics?.aP2p || []

  const p2p = p2pData?.reduce((max, current) => current?.nRuns > (max?.nRuns ?? 0) ? current : max, null)
  const pShip = partnerships?.reduce((max, current) => current?.nRuns > (max?.nRuns ?? 0) ? current : max, null)

  const playerData = {
    img: playerStats?.getPlayerMatchStats?.oPlayerMatchStats?.oPlayer?.oImg?.sUrl || '',
    totalScore: `Total Score : ${currentStats?.oBatStats?.nRuns} (${currentStats?.oBatStats?.nBalls})`,
    vsPace: {
      runs: paceStats?.nRuns || '-',
      balls: paceStats?.nBalls || '-',
      sixes: paceStats?.nSixes || '-',
      strikeRate: paceStats?.sStrikeRate || '-'
    },
    vsSpin: {
      runs: spinStats?.nRuns || '-',
      balls: spinStats?.nBalls || '-',
      sixes: spinStats?.nSixes || '-',
      strikeRate: spinStats?.sStrikeRate || '-'
    },
    timeline: currentStats?.oBatStats?.aTimeline || [],
    battingMatrix: {
      style: currentStats?.oBatStats?.oBattingMetrics?.sBattingStyle,
      running: currentStats?.oBatStats?.oBattingMetrics?.nRunsRunning,
      boundary: currentStats?.oBatStats?.oBattingMetrics?.nRunsBoundary,
      boundaryPercentage: currentStats?.oBatStats?.oBattingMetrics?.sBoundaryPercentage,
      pShip: {
        player: pShip?.oBatter?.sFullName,
        runs: pShip?.nRuns
      },
      p2p: {
        player: p2p?.oBowler?.sFirstName,
        runs: p2p?.nRuns
      }
    },
    commentary: activeTab === 'All' ? currentStats?.oBatStats?.aCommentaries : currentStats?.oBatStats?.aCommentaries?.filter(item => {
      if (activeTab === 'w') return item?.sScore === 'w'
      if (activeTab === '4') return item?.sScore === '4'
      if (activeTab === '6') return item?.sScore === '6'
      if (activeTab === 'highlights') return ['w', '4', '6'].includes(item?.sScore)
      return true
    })
  }

  const tabs = useMemo(() => {
    const allCommentaries = currentStats?.oBatStats?.aCommentaries || []
    const filters = ['w', '4', '6']
    const availableFilters = filters.filter(score =>
      allCommentaries.some(item => item?.sScore === score)
    )
    const filterTabs = availableFilters.map(score => ({
      navItem: score.toUpperCase() + (score !== 'w' ? 's' : ''),
      value: score
    }))
    const baseTabs = [
      { navItem: 'All', value: 'all' },
      ...(availableFilters.length > 0 ? [{ navItem: 'Highlights', value: 'highlights' }] : [])
    ]
    const finalTabs = [...baseTabs, ...filterTabs]
    return finalTabs.length > 1 ? finalTabs : []
  }, [currentStats, matchDetail?.nLatestInningNumber])

  function handleTabChange(tab) {
    setActiveTab(tab.value)
  }

  return (
    <>
      <tr className={`${batter.highlight && 'highlight'} position-relative`}>
        <td>
          <span className="d-flex flex-column flex-md-row">
            <div className={`${styles.batterName} d-flex`}>
              {downDown && (
                <div className={styles.batterImage}>
                  <MyImage src={getImgURL(playerData?.img)} height={35} width={35} placeholderImage={playerPlaceholder}/>
                </div>
              )}
              <div>
                <div className="d-flex align-items-center">
                  {player?.eTagStatus === 'a' ? (
                    <>
                      <span className="d-none d-sm-block">
                          <p onClick={() => setDropdown(prev => !prev)} className="cursor-pointer">
                            {player?.sFullName || player?.sShortName}
                          </p>
                      </span>
                    </>
                  ) : (
                    <span className="d-none d-sm-block">{player?.sFullName || player?.sShortName}</span>
                  )}
                  {player?.eTagStatus === 'a' ? (
                    <>
                      <span className="d-block d-sm-none">
                        {batter?.eDismissal ? (
                          <p
                            onClick={() => setDropdown(prev => !prev)}
                            className="cursor-pointer "
                            style={{
                              whiteSpace: 'nowrap',
                              width: '70px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}>
                            {player?.sFullName || player?.sShortName}
                          </p>
                        ) : (
                          <CustomLink href={`/${playerSlug}`} prefetch={false}>
                            <a>
                              <p
                                className="text-theme-color"
                                style={{
                                  whiteSpace: 'nowrap',
                                  width: '70px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}>
                                {player?.sFullName || player?.sShortName}
                              </p>
                            </a>
                          </CustomLink>
                        )}
                      </span>
                    </>
                  ) : (
                    <span className="d-block d-sm-none">{player?.sShortName || player?.sFullName}</span>
                  )}
                  <span>{isCandW || `${isCaptain} ${isWk}`}</span>
                  {/* {batter?.eDismissal != null && ( */}
                  {!batter?.eDismissal && <p>*</p>}
                  {!downDown && (
                    <p
                      onClick={handleDropdown}
                      className={`ms-2 ${downDown ? `${styles?.rotate_arrow}` : `${styles?.rotate_arrow_reverse}`} cursor-pointer`}>
                      <DownArrow />
                    </p>
                  )}
                </div>
                {downDown && (
                  <CustomLink href={`/${playerSlug}`} prefetch={false}>
                    <a>
                      <p className="text-theme-color mb-0">Open Profile</p>
                    </a>
                  </CustomLink>
                )}
              </div>
            </div>
            {!downDown && (
              <span className={`${styles.subText} ${!batter?.eDismissal === null ? 'orig-theme' : 'text-secondary'}`}>
                {!batter?.eDismissal === null ? 'not out' : batter?.sHowOut}
              </span>
            )}
          </span>
        </td>
        {!downDown &&
          Object.keys(table.current)?.map((value, index) => {
            return <td key={index}>{batter[value]}</td>
          })}
        {downDown && (
          <>
            <td colSpan={5} style={{ verticalAlign: 'middle' }}>
              {
                currentStats?.oBowlStats !== null && (
                  <div className={styles.middleButtonGroup}>
                    <Nav
                      className={`${navStyles.commonNav} ${navStyles.pillsNav} ${styles.nav} justify-content-start mb-2 mt-2 mt-sm-0 flex-nowrap text-nowrap overflow-auto`}
                      variant="pills">
                      {['Batting', 'Bowling']?.map((data, i) => {
                        return (
                          <Nav.Item key={i} className={`${navStyles.item}`}>
                            <a
                              className={`${battingState === data && navStyles.active} nav-link`}
                              onClick={() => {
                                handleBattingState(data)
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center flex-grow-1">{data}</div>
                            </a>
                          </Nav.Item>
                        )
                      })}
                    </Nav>
                  </div>
                )
              }
              <p onClick={() => setDropdown(prev => !prev)} className={` d-inline ${styles.closeBtn}`}>
                Close
              </p>
            </td>
          </>
        )}
      </tr>
      {(downDown && !playerStats?.getPlayerMatchStats?.oPlayerMatchStats?.isDataFlag && !loading) && (
         <tr>
          <td colSpan={6} className="p-0">
            <div className='d-flex justify-content-center align-items-center w-100'>
              <NoData className='w-100' />
            </div>
          </td>
          </tr>
      )}
      {(downDown && playerStats?.getPlayerMatchStats?.oPlayerMatchStats?.isDataFlag && battingState === 'Batting') && (
        <>
          <tr>
            <td colSpan={6} className="p-0">
              <div className={styles.playerCard}>
                <SpiderBatterData currentTeam={currentTeam} data={batter} matchId={matchDetail?._id} totalScore={playerData?.totalScore} />
                {batter?.oCommentary?.sCommentary && (
                  <>
                    <div className={`d-flex position-relative ${styles.playerWicket}`}>
                      <div className="">
                        <div className="ms-1">{`${batter?.oCommentary?.sOver} ${
                          batter?.oCommentary?.sBall && batter?.oCommentary?.sBall > 0 ? `.${batter?.oCommentary?.sBall}` : ''
                        }`}</div>
                        <div
                          className="mt-3 me-3 my-0 py-1 px-1 rounded-pill bg-danger border border-danger text-white d-inline-block text-center"
                          style={{
                            minWidth: '27px',
                            minHeight: '27px',
                            width: '27px',
                            height: '27px',
                            fontSize: '0.75rem',
                            lineHeight: '1.25rem'
                          }}>
                          W
                        </div>
                      </div>
                      <div className="ms-2">
                        <div className="text-start text-wrap">{batter?.oCommentary?.sComSummary || '-'}</div>
                        <div className="mt-3 text-start text-wrap">{batter?.oCommentary?.sText || '-'}</div>
                      </div>
                    </div>
                  </>
                )}
                <table className={styles.BattingTable}>
                  <thead>
                    <th>Batting</th>
                    <th>R</th>
                    <th>B</th>
                    <th>SR</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>vs Pace</td>
                      <td>{playerData?.vsPace?.runs || '-' }</td>
                      <td>{playerData?.vsPace?.balls || '-'}</td>
                      <td>{playerData?.vsPace?.strikeRate || '-'}</td>
                    </tr>
                    <tr>
                      <td>vs Spin</td>
                      <td>{playerData?.vsSpin?.runs || '-'}</td>
                      <td>{playerData?.vsSpin?.balls || '-'}</td>
                      <td>{playerData?.vsSpin?.strikeRate || '-'}</td>
                    </tr>
                  </tbody>
                </table>
                <ScoreTimeLine timeline={playerData?.timeline} />
                <ScorePlayerDetail playerData={playerData} />
                {playerData?.commentary?.length > 0 && (
                  <>
                    <h6 className={styles.commentaryLineHeading}>Commentary</h6>
                    {
                      tabs?.length > 0 && (
                        <Nav className={`ps-2 justify-content-start mb-3 flex-nowrap text-nowrap overflow-auto ${styles.navbar}`} variant="pills">
                          {tabs?.map((data, i) => {
                            return (
                              <Nav.Item key={i} onClick={() => { handleTabChange(data) }}>
                                <div className={`${data?.value === activeTab && `${navStyles.active} text-white`}  ${data.value === activeTab ? `${styles?.text_white} bg-theme-color-orig border-primary` : 'bg-light text-dark border-secondary'} nav-link mx-auto d-flex justify-content-between align-items-center flex-grow-1 cursor-pointer ms-2 me-2`}>{data?.navItem}</div>
                              </Nav.Item>
                            )
                          })}
                        </Nav>
                      )
                    }
                    <Commentary data={playerData?.commentary} activeTab={activeTab}/>
                  </>
                )}
              </div>
            </td>
          </tr>
        </>
      )}

      {(downDown &&
      playerStats?.getPlayerMatchStats?.oPlayerMatchStats?.isDataFlag &&
      battingState === 'Bowling' &&
      currentStats?.oBowlStats !== null) && (
        <tr>
          <td colSpan={6} className="p-0">
            {playerStats?.getPlayerMatchStats?.oPlayerMatchStats?.aStats
              ?.filter(stat => stat?.oBowlStats !== null)
              ?.flatMap(stat => {
                const overs = stat?.oBowlStats?.aOvers || []
                return overs.map((item, i) => {
                  const isLast = i === overs?.length - 1
                  return (
                    <div
                      key={`${item?.sOver}-${i}`}
                      className={!isLast ? styles.borderBottom : ''}
                    >
                      <BowlerOvers playerData={item} />
                    </div>
                  )
                })
              })
            }
          </td>
        </tr>
      )}
    </>
  )
}

BatterDataRow.propTypes = {
  batter: PropTypes.object,
  playerSlug: PropTypes.object,
  table: PropTypes.object,
  capwk: PropTypes.array,
  matchDetail: PropTypes.object,
  currentTeam: PropTypes.number
}

export default BatterDataRow
